export default __webpack_public_path__ + "static/Dunbar-Tall-Book-73aa618f301479a4a4b4d610914aa6db.ttf";